import {i18n} from "../plugins/vue-i18n";
import dateConverter from "../utils/converters/date.converter";

export default {
  methods: {
    buildReportErrorMessage(er, fromHeaders = false) {
      // Define default value
      const contractId = fromHeaders ? er.ContractId : er.contractId;
      const number = fromHeaders ? er.Number.Value : er.number.value;
      const message = fromHeaders ? er.Message.join('; ') : er.message.join('; ');

      return `Ошибка в контракте <a href=\"/contract/edit/${contractId}/assets\">«${number}»</a>: ${message}`;
    }
  }
};
